import { ButtonGroupComponent } from 'components/button-group/button-group-component';
import { Typography } from 'components/typography/typography-component';
import Image from 'next/image';
import { useState } from 'react';

import PlanCard from './release-log-plan-card';

export type BillingPlanPageComponentProps = {
  plans: Array<Plan>;
};

export type SubscriptionType = 'Annually' | 'Monthly';

export type Plan = {
  type: 'STARTER' | 'GROWTH' | 'SCALE' | string;
  price: {
    month: string;
    year: string;
  };
  description: string;
  visitorCount: string;
  benefitHeading: string;
  benefits: Array<string>;
  active?: boolean;
};

const ReleaseLogPlans = ({ plans }: BillingPlanPageComponentProps) => {
  const [subscriptionType, setSubscriptionType] =
    useState<SubscriptionType>('Annually');

  const changeSubscriptionType = (type: SubscriptionType) => {
    setSubscriptionType(type);
  };

  return (
    <div className="pb-10">
      <div className="w-full">
        <Typography className="mb-[3rem] text-center font-GTWalsheimPro text-3xl font-extrabold text-[#27292C] md:text-4xl">
          Choose Your Ideal Plan
        </Typography>
      </div>
      <div className="mb-8 flex justify-center">
        <div className="relative inline-flex -space-x-px">
          {subscriptionType === 'Annually' && (
            <div className="absolute  left-[-22px] top-[-22px] z-50 overflow-visible">
              <Image
                src={'/assets/20-percent-off-icon.svg'}
                alt="20% Off"
                height={40}
                width={40}
              />
            </div>
          )}
          <ButtonGroupComponent
            color="orange"
            buttons={[
              {
                label: 'Annually',
                value: 'Annually',
                onClick: () => changeSubscriptionType('Annually'),
              },
              {
                label: 'Monthly',
                value: 'Monthly',
                onClick: () => changeSubscriptionType('Monthly'),
              },
            ]}
            selectedValue={subscriptionType}
          />
        </div>
      </div>
      <ul className="flex flex-wrap gap-8 ">
        {plans.map(plan => (
          <li className="flex flex-grow  basis-0" key={plan.type}>
            <PlanCard selectedSubscriptionType={subscriptionType} plan={plan} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReleaseLogPlans;
